module.exports = __webpack_public_path__ + "img/roelanddekruijf-bg.abf491e9.jpg";